import React from "react";
import { Box, Typography, Button } from "@mui/material";

interface ChatSessionWarningProps {
  onConfirm: () => void;
  onCancel: () => void;
}

export const ChatSessionWarningContent: React.FC<ChatSessionWarningProps> = ({
  onConfirm,
  onCancel,
}) => {
  return (
    <Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        You have an active chat session. If you navigate away, your chat session
        will be disconnected and you'll lose your conversation history. Are you
        sure you want to continue?
      </Typography>

      <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end" }}>
        <Button onClick={onCancel} variant="outlined">
          Stay on Chat
        </Button>
        <Button onClick={onConfirm} variant="contained">
          Leave & Close Session
        </Button>
      </Box>
    </Box>
  );
};
